import React from 'react';

export default function RenderTextField(props) {
  const { input, meta, ...rest } = props;

  return <div />;
}
